import { Action } from '@ngrx/store';

export const SEARCH_LAUNCH = '[Search] Search launch';

export class SearchLaunch implements Action {
  readonly type = SEARCH_LAUNCH;

  constructor(public payload: string) {}
}

export type SearchAction = SearchLaunch;
